module.exports = __webpack_public_path__ + "img/5.ecc4686c.jpg";